/**
 * @project 中国人群健康大数据平台
 * 
 * @author  Guojun Wang
 * @date    2022-11-21 14:00:00
 **/ 

import React from 'react';
import TweenOne from 'rc-tween-one';
import { Link } from 'rc-scroll-anim';
import { MENU_SUB_LIST } from './data.source';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneOpen: false,
    };
  };

  componentDidMount() {
    // 科研软件子导航
    const item = document.getElementsByClassName('menu-sub-software');
    const res = document.getElementById('header-sub-software');
  
    for (let i = 0; i < 2; i++) {
      item[i].onmouseover = () => {
        res.style.display = 'block';
        res.style.opacity = 1;

        item[0].style.backgroundColor = '#58A7BE';
        item[0].style.color = '#fff';
      }

      item[i].onmouseout = () => {
        res.style.display = 'none';
        res.style.opacity = 0;

        item[0].style.backgroundColor = '#fff';
        item[0].style.color = '#144168';
      }
    }

    // 在线工具子导航
    const item2 = document.getElementsByClassName('menu-sub-portal');
    const res2 = document.getElementById('header-sub-meta');
    
    for (let i = 0; i < 2; i++) {
      item2[i].onmouseover = () => {
        res2.style.display = 'block';
        res.style.opacity = 1;

        item2[0].style.backgroundColor = '#58A7BE';
        item2[0].style.color = '#fff';
      }

      item2[i].onmouseout = () => {
        res2.style.display = 'none';
        res.style.opacity = 0;

        item2[0].style.backgroundColor = '#fff';
        item2[0].style.color = '#144168';
      }
    };
  };

  phoneClick = () => {
    const phoneOpen = !this.state.phoneOpen;
    this.setState({
      phoneOpen,
    });
  };

  render() {
    const { dataSource, isMobile, ...props } = this.props;

    const { phoneOpen } = this.state;
    const { LinkMenu } = dataSource;
    console.log(LinkMenu)
    const navData = LinkMenu.children;

    const logo_label = MENU_SUB_LIST[window.location.pathname];

    const navChildren = Object.keys(navData).map((key, i) => {
      const item = navData[key];
      let tag = Link;
      const tagProps = {};
      
      if (item.to && item.to.match(/\//g)) {
        tagProps.href = item.to;
        tag = 'a';
        delete item.to;
      }
      if(item.name==="SMR PORTAL"){
        tagProps.target="_blank"
      }
      return React.createElement(
        tag,
        { ...item, ...tagProps, key: i.toString() },
        navData[key].children
      );
    });
    console.log(navChildren)
    const moment = phoneOpen === undefined ? 300 : null;
    return (
      <TweenOne
        component="header"
        animation={{ opacity: 0, type: 'from' }}
        {...dataSource.wrapper}
        {...props}
      >
        <div
          {...dataSource.page}
          className={`${dataSource.page.className}${phoneOpen ? ' open' : ''}`}
        >
          <TweenOne
            animation={{ x: -30, type: 'from', ease: 'easeOutQuad' }}
            {...dataSource.logo}
          >
            <a name='logo' href='/'>
              <div className='logo-english-name'>OMICS BIG DATA AND POPULATION</div>
              <div className='logo-english-name'>HEALTH PLATFORM</div>
              <div className='logo-chinese-name'>
                <div className='chinese-name-title'>组学大数据和群体健康平台</div>
                {
                  logo_label !== undefined ? (
                    <div className='chinese-name-page'>{logo_label}</div>
                  ) : null
                }
              </div>
            </a>
          </TweenOne>
          {isMobile && (
            <div
              {...dataSource.mobileMenu}
              onClick={() => {
                this.phoneClick();
              }}
            >
              <em />
              <em />
              <em />
            </div>
          )}
          <TweenOne
            {...LinkMenu}
            animation={
              isMobile
                ? {
                    height: 0,
                    duration: 300,
                    onComplete: (e) => {
                      if (this.state.phoneOpen) {
                        e.target.style.height = 'auto';
                      }
                    },
                    ease: 'easeInOutQuad',
                  }
                : null
            }
            moment={moment}
            reverse={!!phoneOpen}
            style={{ fontWeight: 'bolder', fontSize: '16px' }}
          >
            {navChildren}
            <div className="header-sub-children">
              {/* 科研软件 */}
              <div className="header-sub-li menu-sub-software" id="header-sub-software">
                <div className="header-sub-inline">
                  <a href="/software-gcta" className="menu-item-list">GCTA</a>
                  <a href="/software-smr" className="menu-item-list">SMR</a>
                  <a href="/software-gsmr" className="menu-item-list">GSMR</a>
                  <a href="/software-osca" className="menu-item-list">OSCA</a>
                  <a href="https://github.com/Yves-CHEN/DENTIST" target="_blank" rel="noopener noreferrer" className="menu-item-list">DENTIST</a>
                  <a href="/software-thistle" className="menu-item-list">THISTLE</a>
                  <a href="https://github.com/LeonSong1995/MeDuSA" target="_blank" rel="noopener noreferrer" className="menu-item-list">MeDuSA</a>
                  <a href="https://github.com/wuyangf7/OPERA" target="_blank" rel="noopener noreferrer" className="menu-item-list">OPERA</a>
                </div>
              </div>
              
              {/* 在线工具 */}
              <div className="header-sub-li menu-sub-portal" id="header-sub-meta">
                <div className="header-sub-inline">
                  <a href="/meta" className="menu-item-list">BrainMeta</a>
                  <a href="/data" className="menu-item-list">fastGWA</a>
                </div>
              </div>
            </div>
          </TweenOne>
        </div>
      </TweenOne>
    );
  }
}

export default Header;
